import { RegisterOptions } from 'react-hook-form';

import { ErrorType, RegisterType } from 'types';

import { FlagLabel, FlagName } from 'components/FlagLabel';
import { Label } from 'components/Label';

import * as S from './TextArea.styles';
import { StyledAreaProps } from './TextArea.styles';

type TextAreaProps = {
  name: string;
  value?: string | number;
  label?: string;
  flag?: FlagName;
  register?: RegisterType;
  options?: RegisterOptions;
  error?: ErrorType;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  onKeyDown?: (e: KeyboardEvent) => void;
  placeholder?: string;
} & StyledAreaProps;

export function TextArea(props: TextAreaProps): React.ReactElement {
  const {
    name,
    value = undefined,
    label = undefined,
    flag = undefined,
    register = undefined,
    options = undefined,
    error = undefined,
    disabled = false,
    required = false,
    className = undefined,
    onKeyDown = undefined,
    motive = 'default',
    placeholder = '',
  } = props;

  const area = register ? (
    <S.Area
      disabled={disabled}
      onKeyDown={(e: unknown) => onKeyDown && onKeyDown(e as KeyboardEvent)}
      {...register(name, options)}
      withNoLabel={!label}
      defaultValue={value}
      required={required}
      placeholder={placeholder}
    />
  ) : (
    <S.Area
      name={name}
      disabled={disabled}
      withNoLabel={!label}
      defaultValue={value}
      required={required}
      onKeyDown={(e: unknown) => onKeyDown && onKeyDown(e as KeyboardEvent)}
      placeholder={placeholder}
    />
  );

  return (
    <S.Container motive={motive} className={className}>
      {label ? (
        <Label required={required} error={error}>
          {label}
        </Label>
      ) : null}

      {flag ? (
        <S.FlagWrapper withNoLabel={!label}>
          <FlagLabel type={flag} />

          {area}
        </S.FlagWrapper>
      ) : (
        area
      )}
    </S.Container>
  );
}
